import React from 'react';
import { ThemeProvider as MUIThemeProvider } from '@material-ui/core';
import muiTheme from './muiTheme';

const ThemeProvider: React.FC = ({ children }) => {
  return <MUIThemeProvider theme={muiTheme()}>{children}</MUIThemeProvider>;
};

export default ThemeProvider;
